

export default function StartupIcon({ className }) {
    return (
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2 8.66667H9.8V10.1111H11.2M11.2 5.77778H9.8V7.22222H11.2M12.6 11.5556H7V10.1111H8.4V8.66667H7V7.22222H8.4V5.77778H7V4.33333H12.6M5.6 2.88889H4.2V1.44444H5.6M5.6 5.77778H4.2V4.33333H5.6M5.6 8.66667H4.2V7.22222H5.6M5.6 11.5556H4.2V10.1111H5.6M2.8 2.88889H1.4V1.44444H2.8M2.8 5.77778H1.4V4.33333H2.8M2.8 8.66667H1.4V7.22222H2.8M2.8 11.5556H1.4V10.1111H2.8M7 2.88889V0H0V13H14V2.88889H7Z" fill={className} />
        </svg>

    )
}
